<template>
  <main class="main colors">
    <div class="f container">
      <LazyUiBreadCrumbsV2
          :items="[
              {
                title: t('teams_label') || '',
                link: localePath('/teams')
              },
              {
                title: data?.data?.getProTeam?.title || '',
                link: localePath('/teams/' + route.params.id)
              }
          ]"
      />
    </div>
    <PagesTeam
        :data="data?.data?.getProTeam || {} as ProTeam"
        :loading="status === 'pending'"
    />
  </main>
</template>


<script lang="ts" setup>
import {getTeam} from "~/utils/api";
import type {ProTeam} from "~/graphql/generated/schema-types";

const localePath = useLocalePath()
const {t, locale} = useI18n()
const route = useRoute()

const {error, data, status} = await useAsyncData(
    'getTeam',
    () => getTeam(route.params.id as string, locale.value),
    {watch: [locale]}
);

if (error.value || data?.value?.errors?.length) {
  throw createError({
    status: 404,
    statusText: 'Team page error: ' + (error.value?.message || data?.value?.errors?.[0]?.message || '')
  })
}

const title = t('heads.team.title', {name: data?.value?.data?.getProTeam?.title})
const description = t('heads.team.description', {name: data?.value?.data?.getProTeam?.title})
const weaponIcon = 'https://csmarketcap.com/img/logo-bg-black.png'

const {
  alternateLinks,
  canonical
} = useAlternateLinks('/teams/' + route.params.id)

useHead({
  title: () => title,
  meta: [
    {
      name: "keywords",
      content: "steam, counter strike global offensive, csgo, cs2, skins, items",
    },
  ],
  link: () => alternateLinks.value
})

useSeoMeta({
  title: () => title,
  ogTitle: () => title,
  description: () => description,
  ogDescription: () => description,
  ogImage: () => weaponIcon,
  twitterCard: 'summary_large_image',
  twitterTitle: () => title,
  twitterDescription: () => description,
  twitterImage: () => weaponIcon,
  ogSiteName: 'CSMarketCap',
  ogUrl: () => canonical.value,
  ogType: 'website',
  ogLocale: () => locale.value
})

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      {name: t('main'), item: '/'},
      {
        name: t('teams_label'),
        item: localePath('/teams')
      },
      {
        name: title,
        item: localePath('/teams/' + route.params.id)
      },
    ],
  }),
  defineItemList({
    name: 'CS2 Players',
    itemListElement: data.value?.data?.getProTeam?.players.map((player, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Person',
        name: player?.general?.nick_name,
        nationality: player?.general?.country,
        memberOf: player?.general?.team,
      },
    })),
  })
])
</script>

<style lang="scss" scoped>
.main {
  margin-top: 20px;
}
</style>
